import React, { useState, useEffect, useRef, useImperativeHandle } from "react";
import Speech from "react-text-to-speech";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import VolumeOffIcon from "@mui/icons-material/VolumeOff";
import CachedIcon from "@mui/icons-material/Cached";
import { Stack } from "@mui/material";
import { Padding } from "@mui/icons-material";

const Captcha = React.forwardRef((props, ref) => {
  const { onChangeCaptcha } = props;

  const canvas = {
    // border: "10px solid #eeeeee",
    borderRadius: "20px",
    textAlign: "left",
    fontStyle: "Italic",
    alignItems: "center",
    PaddingLeft: "0px",
  };

  const [captchaText, setCaptchaText] = useState("");
  const [captchaAudioText, setCaptchaAudioText] = useState("");
  const canvasRef = useRef(null);

  useImperativeHandle(ref, () => ({
    captchaReload: captchaReload,
  }));

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    initializeCaptcha(ctx);
  }, []);

  const generateRandomChar = (min, max) =>
    String.fromCharCode(Math.floor(Math.random() * (max - min + 1) + min));

  const generateCaptchaText = () => {
    let captcha = "";
    for (let i = 0; i < 2; i++) {
      captcha += generateRandomChar(65, 90);
      captcha += generateRandomChar(97, 122);
      captcha += generateRandomChar(48, 57);
    }
    return captcha
      .split("")
      .sort(() => Math.random() - 0.5)
      .join("")
      .toUpperCase();
  };

  const drawCaptchaOnCanvas = (ctx, captcha) => {
    ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
    const textColors = ["rgb(0,0,0)", "rgb(130,130,130)"];
    const letterSpace = 150 / captcha.length;
    for (let i = 0; i < captcha.length; i++) {
      const xInitialSpace = 25;
      ctx.font = "20px Roboto Mono";
      ctx.fillStyle = textColors[Math.floor(Math.random() * 2)];
      ctx.fillText(
        captcha[i],
        xInitialSpace + i * letterSpace,

        // Randomize Y position slightly
        Math.floor(Math.random() * 16 + 25),
        100
      );
    }
  };

  const initializeCaptcha = (ctx) => {
    const newCaptcha = generateCaptchaText();
    setCaptchaText(newCaptcha);
    setCaptchaAudioText(newCaptcha.split("").join(" "));
    onChangeCaptcha(newCaptcha);
    drawCaptchaOnCanvas(ctx, newCaptcha);
  };

  const captchaReload = () => {
    initializeCaptcha(canvasRef.current.getContext("2d"));
  };

  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <div className="captcha-can">
        <canvas ref={canvasRef} style={canvas} width="200" height="50"></canvas>
      </div>
      <Stack direction="row" spacing={1} justifyContent="space-between">
        <CachedIcon
          className="cpa-icon"
          id="reload-button"
          onClick={captchaReload}
        />

        <Speech
          text={captchaAudioText}
          pitch={1}
          rate={0.3}
          volume={1}
          voiceURI="Microsoft Heera - English (India)"
        >
          {({ speechStatus, isInQueue, start, pause, stop }) => (
            <div
              style={{
                display: "flex",
                columnGap: "0.5rem",
                marginRight: "100%",
              }}
            >
              {speechStatus !== "started" ? (
                <VolumeOffIcon className="cpa-icon" onClick={start} />
              ) : (
                <VolumeUpIcon className="cpa-icon" onClick={stop} />
              )}
            </div>
          )}
        </Speech>
      </Stack>
    </div>
  );
});

export default Captcha;
